import { Checkbox as CheckboxHeadless } from "@headlessui/react";

type CheckboxProps = {
    className?: string;
    classTick?: string;
    label?: string;
    /** Accessible name when there is no visible label (a row selector). */
    ariaLabel?: string;
    checked: boolean;
    disabled?: boolean;
    onChange: (value: boolean) => void;
};

/*
 * Checked: the accent fill inside a ring of --accent-stroke (border-accent), so the state reads at 3:1 on
 * the page whatever the brand; a light brand's square alone (a lime) would not.
 */
const Checkbox = ({
    className,
    classTick,
    label,
    ariaLabel,
    checked,
    disabled,
    onChange,
}: CheckboxProps) => (
    <CheckboxHeadless
        className={`group flex items-center gap-3 cursor-pointer data-[disabled]:cursor-default data-[disabled]:opacity-50 ${
            className || ""
        }`}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        aria-label={label ? undefined : ariaLabel}
    >
        <span
            className={`relative shrink-0 size-6 rounded-[6px] border-2 border-s-stroke2 transition-colors before:absolute before:top-0.5 before:start-0.5 before:w-4 before:h-4 before:rounded-[2px] before:bg-accent before:opacity-0 before:transition-opacity group-data-[hover]:border-accent/30 group-data-[checked]:border-accent group-data-[checked]:before:opacity-100 ${
                classTick || ""
            }`}
        ></span>
        {label && <span className="text-button">{label}</span>}
    </CheckboxHeadless>
);

export default Checkbox;
